import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Radio } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("fabian.koestner99@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0C10] px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-lg bg-[#E5FF00] flex items-center justify-center">
            <Radio className="w-7 h-7 text-black" />
          </div>
          <div>
            <h1 className="font-display font-black text-3xl uppercase tracking-wide leading-none">
              LED<span className="text-[#E5FF00]">Board</span>
            </h1>
            <p className="text-xs text-[#8A99AD] tracking-widest uppercase">Broadcast Control</p>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#121620] border border-[#1E2638] rounded-2xl p-8 space-y-5"
          data-testid="login-form"
        >
          <h2 className="font-display uppercase tracking-wider text-xl">Anmelden</h2>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#8A99AD]">E-Mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-1 w-full bg-[#0A0C10] border border-[#1E2638] rounded-lg px-4 py-3 outline-none focus:border-[#00F0FF] transition-colors"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#8A99AD]">Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-1 w-full bg-[#0A0C10] border border-[#1E2638] rounded-lg px-4 py-3 outline-none focus:border-[#00F0FF] transition-colors"
            />
          </div>
          {error && (
            <p className="text-sm text-[#FF2A55]" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-[#E5FF00] text-black font-display font-bold uppercase tracking-wider py-3 rounded-lg hover:bg-white transition-colors disabled:opacity-50"
          >
            {loading ? "…" : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
